import { Component, Input, OnInit } from '@angular/core';
 import {  DrawingService,  StyleService } from 'projects/kiosk-app/src/app/services';
 import { ProfileService } from '../../../../services/profile.service';
 import { Observable, take, switchMap } from 'rxjs';
 import { MainTemplate } from 'projects/kiosk-app/src/app/models';
 import { TemplateSetting } from 'projects/kiosk-app/src/app/models/template';
 import { interval, Subject } from 'rxjs';
 import { takeUntil } from 'rxjs/operators';
 import { JoinGoDecoratorDrawing, JoingoDrawing, UCJoinGoDrawing } from 'projects/kiosk-app/src/app/models/drawing';
 
 
 @Component({
   selector: 'app-joingo-template',
   templateUrl: './joingo-template.component.html',
   styleUrls: ['./joingo-template.component.scss'],
 })
 export class JoingoTemplateComponent implements OnInit {
   @Input()
   public tab!:  TemplateSetting;
 
   @Input()
   public mainTemplate!: MainTemplate;
 
   @Input()
   public indexes: [any, any] = [] as any;

   @Input()
   public items: any[] = [];

 
   public isLoading = false;
   public joingoDrawing: JoinGoDecoratorDrawing[]= [];
 
   public buttonIsDisabled = false;

   public slides: any[] | undefined;
   public bError = true;
   public itemsPerPage: number = 6;
   private destroy$ = new Subject<void>();
 
   constructor(
     public styleService: StyleService,
     public readonly profileService: ProfileService,
     private drawingService: DrawingService
   ) {}
 
   ngOnInit() {
    interval(60000)
    .pipe(takeUntil(this.destroy$))
    .subscribe(() => {
      this.checkAndActivateButtons();
   
    })
   }
 
 
   private checkAndActivateButtons(): void {
     this.items.forEach((item: JoinGoDecoratorDrawing) => {
       const now = new Date();
       const conductAt = new Date(item.universalConnectorData.conductAt);
 
       if (conductAt <= now && item.universalConnectorData.state !== 'Activated') {
         item.buttonIsDisabled = false; 
       } else {
         item.buttonIsDisabled = true;
       }
     });
   }
 
   ngOnDestroy() {
     this.destroy$.next();
     this.destroy$.complete();
   }
 
 
   public async activateJoingoDrawing(drawingCMS: any) {
 
     try {
       const response =
         await this.profileService.universalConnector.getJoinGoDrawingAvtivate(
           this.playerProfile.playerId,
           drawingCMS
         );
 
       //check 4 errors
       if (response?.error) {
         console.error('Response Error:', response.error);
         this.bError = true;
       } else {
         console.log('Response:', response.message);
         if (response.message.toLowerCase().startsWith('fail')) {
           this.bError = true;
         } else {
           this.bError = false;
          this.slides = [...(this.slides ?? [])];
         }
       }
     } catch (error: any) {
       console.error('Error:', error);
     }
   }
 
   isDatePast(dateStr: string): boolean {
     this.buttonIsDisabled = true;
     const date = new Date(dateStr);
     const now = new Date();
     return date > now;
   }
 

   getButtonState(drawing: JoinGoDecoratorDrawing): string {
     const now = new Date();
     const conductAt = new Date(drawing?.universalConnectorData.conductAt);
 
     if (conductAt > now) {
       return 'preActive';
     } else if (conductAt <= now && drawing?.universalConnectorData.state == "Activated") {
       return 'activated';
     }
 
     return 'activate';
 
   }
 
   public get playerProfile() {
     return this.profileService.playerProfile;
   }
 
 
  }